import { Modal } from 'react-bootstrap'
import { UseFormWatch } from 'react-hook-form'
import ComponentePrivado from '../../../components/roles/ComponentePrivado'
import { Roles } from '../../../utils/Roles'
import { TTareaForm } from '../models'

type Props = {
  isModoEditar: boolean
  isLoadingGuardar: boolean
  isLoadingActualizar: boolean
  close: () => void
  watch: UseFormWatch<TTareaForm>
}

export const ModalTareaFooter = ({
  isModoEditar,
  isLoadingGuardar,
  isLoadingActualizar,
  close,
  watch,
}: Props) => {
  const watchEstatus = watch('estatus')
  return (
    <Modal.Footer>
      <div className='overlay overlay-block overlay-wrapper overlay-layer'>
        <button
          disabled={isLoadingActualizar || isLoadingGuardar}
          type='reset'
          className='btn  text-hover-dark btn-cancelar'
          onClick={close}>
          Cancelar
        </button>
        <ComponentePrivado rolMostrarPorPermiso={[Roles.roleTareasCrear]}>
          <button
            className='btn btn-primary p-3'
            form='form-tarea'
            type='submit'
            disabled={isLoadingActualizar || isLoadingGuardar}>
            {/*
              Label dinámico según contexto:
              - Crear: "Guardar tarea"
              - Editar: "Actualizar tarea"
              - Cuando el estatus seleccionado es COMPLETADA: el contenedor dispara el flujo
                de cierre (comentario + evidencia) antes de persistir.
            */}
            {isModoEditar && watchEstatus?.valor !== 'COMPLETADA'
              ? 'Actualizar tarea'
              : watchEstatus?.valor === 'COMPLETADA'
              ? 'Finalizar tarea'
              : 'Guardar tarea'}
          </button>
        </ComponentePrivado>
      </div>
    </Modal.Footer>
  )
}
